import { FlaskConical, RotateCcw } from 'lucide-react'
import { Button } from '@/components/occurrences/button'
import { NativeSelect, NativeSelectOption } from '@/components/ui/native-select'
import { PERSONA } from '@/mocks/occurrences/catalog'
import { useOccurrenceMock } from '@/mocks/occurrences/store'
import type { MockProfile } from '@/types/occurrence'
import { PROFILE_LABEL } from '@/types/occurrence'

/** Faixa fixa do protótipo: troca de perfil simulado e reset dos dados. */
export const PrototypeBar = () => {
	const profile = useOccurrenceMock((s) => s.profile)
	const setProfile = useOccurrenceMock((s) => s.setProfile)
	const reset = useOccurrenceMock((s) => s.reset)

	return (
		<div className="border-b border-kaefer-honey-yellow/50 bg-kaefer-honey-yellow/15 px-4 py-2 sm:px-6">
			<div className="flex flex-wrap items-center gap-x-4 gap-y-2">
				<span className="flex items-center gap-1.5 text-xs font-semibold text-kaefer-dark-grey">
					<FlaskConical className="size-4" />
					PROTÓTIPO · dados fictícios · nada é enviado ao servidor
				</span>
				<div className="flex items-center gap-2">
					<label
						htmlFor="mock-profile"
						className="text-xs text-kaefer-dark-grey"
					>
						Simular perfil:
					</label>
					<div className="w-56">
						<NativeSelect
							id="mock-profile"
							size="sm"
							value={profile}
							onChange={(e) => setProfile(e.target.value as MockProfile)}
						>
							{(Object.keys(PROFILE_LABEL) as MockProfile[]).map((p) => (
								<NativeSelectOption key={p} value={p}>
									{PROFILE_LABEL[p]}
								</NativeSelectOption>
							))}
						</NativeSelect>
					</div>
				</div>
				<span className="text-xs text-muted-foreground">
					{PERSONA[profile].name} · escopo: {PERSONA[profile].scope}
				</span>
				<Button
					variant="ghost"
					size="sm"
					className="ml-auto h-7 gap-1 text-xs"
					onClick={reset}
				>
					<RotateCcw className="size-3" /> Restaurar dados
				</Button>
			</div>
		</div>
	)
}
